import React from 'react';

export default class Settings extends React.Component {
  render() {
    return <div className="card ml-2 mt-2">Settings</div>
  }
}
